export function formatCreditMoney(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '0.00';
  return n.toFixed(2);
}

export function formatCreditDate(value) {
  if (!value) return '—';
  return new Date(value).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function formatCreditDateTime(value) {
  if (!value) return '—';
  return new Date(value).toLocaleString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatCreditSource(source) {
  if (!source) return '—';
  return String(source).replace(/_/g, ' ');
}

export function formatCreditStatus(status) {
  if (!status) return '—';
  return String(status).replace(/_/g, ' ');
}
